/** Floating tariff (new) /metering/bill/float-price (floatPrice.vue) */
export default {
  floatPriceBillPage: {
    phDateStart: 'Start date',
    phDateEnd: 'End date',
    btnSearch: 'Search',
    btnReset: 'Reset',
    btnExport: 'Export',
    sortDefault: 'Default sort',
    selectedLine: '<span class="count">{count}</span> row(s) selected',
    sectionTitle: 'Floating tariff list',
    btnCreateFloat: 'Floating tariff',
    colRid: 'Serial no.',
    colFloatRange: 'Period',
    colFloatType: 'Float type',
    colBillDate: 'Bill date',
    colTargetPrice: 'Target tariff (sharp/peak/flat/valley)',
    colFloatAmount: 'Float amount',
    colCreator: 'Created by',
    colCreateTime: 'Created',
    colDetail: 'Details',
    btnDetail: 'Details',
    floatTypeGlobal: 'Global',
    floatTypePart: 'Partial',
    unitYuan: ' yuan',
    emptyNoViewPerm: 'No permission to view',
    drawerTitleCreate: 'Floating tariff',
    drawerTitleDetail: 'Floating tariff details',
    panelSelectTenant: 'Select tenants',
    panelTenantTier: 'Tenant hierarchy',
    panelTenantList: 'Tenant list',
    phSelectTenantTier: 'Select tenant hierarchy',
    phSearchTenant: 'Search tenants…',
    tenantAll: 'All tenants',
    tenantListEmpty: 'No matching tenants',
    cardBasicConfig: 'Basic settings',
    lblDateRange: 'Period',
    phStartTime: 'Start',
    phEndTime: 'End',
    rangeTo: 'to',
    lblFloatType: 'Float type',
    phFloatType: 'Select float type',
    btnQueryUsage: 'Query usage',
    tipQueryPrereq: 'Select tenants, period, and float type first',
    cardUsageStats: 'Usage summary',
    statsRecords: '{count} record(s)',
    statsSelected: ', {count} selected',
    cardPriceFloat: 'Tariff adjustment',
    colTenantName: 'Tenant',
    colPartName: 'Meter / share group',
    colBindType: 'Type',
    colPeakKwh: 'Sharp (kWh)',
    colTopKwh: 'Peak (kWh)',
    colFlatKwh: 'Flat (kWh)',
    colValleyKwh: 'Valley (kWh)',
    colSettledAmount: 'Settled (¥)',
    colTargetAmount: 'Target (¥)',
    colFloatAmountYuan: 'Float (¥)',
    lblPeakPrice: 'Sharp rate',
    lblTopPrice: 'Peak rate',
    lblFlatPrice: 'Flat rate',
    lblValleyPrice: 'Valley rate',
    unitPerKwh: '¥/kWh',
    phPriceZero: '0.00000',
    lblBillDate: 'Bill date',
    phBillDate: 'Select bill date',
    lblRemark: 'Remark',
    phRemark: 'Enter remark (max 200)',
    btnCancel: 'Cancel',
    btnConfirmCreate: 'Create',
    btnClose: 'Close',
    detailBasicInfo: 'Overview',
    detailTargetPrice: 'Target prices',
    detailFloatItems: 'Line items',
    lblRid: 'Serial:',
    detailLblFloatType: 'Float type:',
    lblCreateTime: 'Created:',
    lblCreator: 'Creator:',
    lblDateRangeDetail: 'Period:',
    lblBillDateDetail: 'Bill date:',
    lblTotalFloat: 'Total float balance:',
    detailRecordsCount: '{count} line(s)',
    colUseElecGroup: 'Energy (kWh)',
    colSharp: 'S',
    colPeak: 'P',
    colFlat: 'F',
    colValley: 'V',
    detailColAlready: 'Settled',
    detailColFloatAmt: 'Float',
    detailColTargetBal: 'Target balance',
    bindTypeDedicated: 'Dedicated meter',
    bindTypeShare: 'Shared meter',
    bindTypeFormula: 'Formula meter',
    bindTypeUnknown: 'Unknown',
    msgFetchFail: 'Failed to load data',
    msgTenantListFail: 'Failed to load tenants',
    msgNoCreatePerm: 'No permission to create floating tariff',
    msgQuerySuccess: 'Query completed',
    msgQueryFail: 'Query failed',
    msgSubmitPriceInvalid: 'At least one of sharp/peak/flat/valley rates must be greater than 0',
    msgCreateSuccess: 'Created successfully',
    msgCreateFail: 'Create failed',
    msgNoViewPerm: 'No permission to view',
    msgDetailFail: 'Failed to load details',
    msgNoDataExport: 'No data to export',
    msgExportOk: 'Exported {count} row(s).',
    msgExportOkSelected: 'Exported {count} selected row(s).',
    msgExportFail: 'Export failed. Please try again.',
    expColRid: 'Serial no.',
    expColRange: 'Period',
    expColFloatType: 'Float type',
    expColBillDate: 'Bill date',
    expColTarget: 'Target tariff (S/P/F/V)',
    expColFloatAmt: 'Float amount (¥)',
    expColCreator: 'Created by',
    expColCreateTime: 'Created',
    exportSheetName: 'Floating tariff',
    filePrefix: 'FloatingTariff',
    // Export (current page / selected / all) unified copy
    exportCurrentPage: 'Export current page',
    exportSelected: 'Export selected',
    exportAll: 'Export all',
    warnNoSelectedExport: 'Please select rows to export first',
    successExported: 'Exported {count} row(s).',
    successExportedLimit: '{total} matched, up to {count} per export, first {count} exported',
    exporting: 'Exporting all data...'
  }
}
